export const buildSiteRows = (sites = [], configurations = [], campaigns = []) => {
  const names = new Map(campaigns.map(campaign => [campaign.id, campaign.displayName || campaign.id]));
  const links = new Map();
  configurations.forEach(configuration => {
    const siteId = configuration.targetSiteId || configuration.targetSite?.siteId;
    if (!siteId || !configuration.campaignId) return;
    if (!links.has(siteId)) links.set(siteId, new Map());
    const campaignsById = links.get(siteId);
    const previous = campaignsById.get(configuration.campaignId);
    campaignsById.set(configuration.campaignId, {
      id: configuration.campaignId,
      displayName: names.get(configuration.campaignId) || configuration.campaignId,
      archived: Boolean(configuration.archivedAt) && (!previous || previous.archived)
    });
  });
  return sites.map(site => ({
    ...site,
    campaigns: [...(links.get(site.id)?.values() || [])].sort((a, b) => a.displayName.localeCompare(b.displayName))
  }));
};

export const filterAndSortSites = (sites, search, campaignId, sortBy = []) => {
  const term = search.trim().toLowerCase();
  const { id = 'displayName', desc = false } = sortBy[0] || {};
  const value = site => {
    if (id === 'campaigns') return site.campaigns.map(campaign => campaign.displayName).join(', ');
    if (id === 'type.displayName') return site.type?.displayName || '';
    return site[id] || '';
  };
  return sites
    .filter(site => (!term || `${site.displayName || ''} ${site.id}`.toLowerCase().includes(term)) &&
      (!campaignId || site.campaigns.some(campaign => campaign.id === campaignId)))
    .sort((a, b) => (String(value(a)).localeCompare(String(value(b))) || String(a.id).localeCompare(String(b.id))) *
      (desc ? -1 : 1));
};
